export const appConfig={
    name: '景区大数据', 
    namePrefix:'天山天池',
    requestUrl: 'https://sso.xjtstc.com/analysis', // 'http://biaozhunhua.zjht100.com/tsscjk',// tsxjjk  tsscjk 'http://biaozhunhua.zjht100.com/yswb',// 业务系统接口请求地址
    requestAnalysisUrl:"https://222.128.10.58:9018",// "http://222.128.10.58:9018",// "http://biaozhunhua.zjht100.com/tsscstatistics",// "http://biaozhunhua.zjht100.com/ysstatistics",//大数据接口地址
    aMapKey:'8288967d08a26d371d904ce8574196b6',//高德jsApi key
    requestUrlPermissions: 'https://sso.xjtstc.com/jk/permissions-api/permissions', //权限接口
    permissionUrl: 'https://sso.xjtstc.com/fbkfpermissions',//'http://biaozhunhua.zjht100.com/fbkfpermissions',// 
    requestDataCenterUrl: 'http:/sso.xjtstc.com/data-api/data/data-server',
    imgRequestUrl:'http://222.128.10.58:9024/preview?file_id=',
    screen:{
        width:1920, //3840,// 
        height:1080,
        scale:20
    },//大屏设计宽高
    loginInfo:{
        source: 'ggfw',
        userAvatar: 'https://sso.xjtstc.com/common-api/common/preview?file_id=5f7b2b8535ba514a24f3ceaf',// 'images/zjht_logo.png',
        perSystemCode:'S1604976716131666',// 'S1591596269763369',
        perProjectCode: 'P1601460953736888',//'P159143027723650',
        userLogoName: '天山天池云数据中心',
        loginUrl: 'https://sso.xjtstc.com/fbkfpermissions/login.html'//   'http://biaozhunhua.zjht100.com/auth/login.html'
    },
    //巡检模块登录配置
    patrolLoginInfo:{
        source: 'ggfw',
        userAvatar: 'https://sso.xjtstc.com/common-api/common/preview?file_id=5f7b2b8535ba514a24f3ceaf',
        perSystemCode:'S1595838748438932',// '巡检任务系统',
        perProjectCode: 'P1601460953736888',//'P159143027723650',
        userLogoName: '天山天池巡检平台',
        loginUrl: 'https://sso.xjtstc.com/fbkfpermissions/login.html'
    },
    area:{
        name:"阜康市",
        code:"652302",
        type:3,
        areaType:1,
        weatherCityName:'阜康市',
        poi:'88.127965771,43.885640247'
    },
    map:{
        center:{
          longitude:88.127965771,
          latitude:43.885640247,
          height:10000,
          heading:-30
        }
    },
    supermap:{

        sceneURL:"https://gis.xjtstc.com/iserver/services/3D-local3DCache-dom002zjtstc/rest/realspace/datas/dom002@zj_tstc",
        // terrainURL:"https://tsscgis.zjht100.com/iserver/services/3D-local3DCache-tstcdemzjtstcdem/rest/realspace/datas/tstc_dem@zj_tstc_dem",//小范围
        terrainURL:"https://gis.xjtstc.com/iserver/services/3D-local3DCache-fktstcdem/rest/realspace/datas/fk_tstc_dem",//融合地形
        modelPointArray:[
            // {
            //     code:'fushouguan',
            //     name:'福寿观',
            //     longitude:88.1130555555555,
            //     latitude:43.8947222222222,
            //     height:2500,
            //     heading:239,
            //     pitch:-25,
            //     bgUrl:'https://gis.xjtstc.com/iserver/services/3D-local3DCache-tstcmodel05/rest/realspace/datas/c5_bg/config',
            //     modelUrl:'https://gis.xjtstc.com/iserver/services/3D-local3DCache-ModelEdit511hhh2/rest/realspace/datas/ModelEdit_5_1_1@hhh/config'
            // },
            // {
            //     code:'parking',
            //     name:'停车场',
            //     longitude:'',
            //     latitude:'',
            //     height:3000,
            //     heading:0,
            //     pitch:-30,
            //     bgUrl:'https://gis.xjtstc.com/iserver/services/3D-local3DCache-tstcmodel01/rest/realspace/datas/c1_bg/config',
            //     modelUrl:'https://gis.xjtstc.com/iserver/services/3D-local3DCache-tstcmodel012/rest/realspace/datas/c1_model/config'
            // },
            // {
            //     code:'shipyard',
            //     name:'船坞',
            //     longitude:88.1222222222222,
            //     latitude:43.7519444444444,
            //     height:3000,
            //     heading:320,
            //     pitch:-30,
            //     bgUrl:'https://gis.xjtstc.com/iserver/services/3D-local3DCache-tstcmodel04/rest/realspace/datas/c4_bg/config',
            //     modelUrl:'https://gis.xjtstc.com/iserver/services/3D-local3DCache-tstcmodel042/rest/realspace/datas/c4_model/config'
            // },
            // {
            //     code:'shipyard2',
            //     name:'船坞2',
            //     longitude:88.1222222222222,
            //     latitude:43.7519444444444,
            //     height:3000,
            //     heading:320,
            //     pitch:-30,
            //     bgUrl:'https://gis.xjtstc.com/iserver/services/3D-local3DCache-Data7/rest/realspace/datas/c2_bg/config',
            //     modelUrl:'https://gis.xjtstc.com/iserver/services/3D-local3DCache-Data8/rest/realspace/datas/c2_model/config'
            // },
            // {
            //     code:'xiwangmumiao',
            //     name:'西王母庙',
            //     longitude:88.1386111111111,
            //     latitude:43.9022222222222,
            //     height:1000,
            //     heading:17.89,
            //     pitch:-25,
            //     bgUrl:'',
            //     modelUrl:''
            // }
            // {
            //     code:'entrance',
            //     name:'景区入口',
            //     longitude:'',
            //     latitude:'',
            //     height:1000,
            //     heading:0,
            //     pitch:-30
            // },
            
            {
                code:'suodaoxiazhan',
                name:'索道下站',
                modelUrl:'https://gis.xjtstc.com/iserver/services/3D-local3DCache-suodao1/rest/realspace/datas/Combine/config'
            },
            {
                code:'suodaoshangzhan',
                name:'索道上站',
                modelUrl:'https://gis.xjtstc.com/iserver/services/3D-local3DCache-suodao2/rest/realspace/datas/Combine/config'
            },
            {
                code:'haibei1',
                name:'海北1',
                modelUrl:'http://gis.xjtstc.com/iserver/services/3D-local3DCache-haibei1/rest/realspace/datas/Combine/config'
            },
            {
                code:'haibei2',
                name:'海北2',
                modelUrl:'http://gis.xjtstc.com/iserver/services/3D-local3DCache-haibei2/rest/realspace/datas/Combine/config'
            },
            {
                code:'wangmu1',
                name:'王母祖庙1',
                modelUrl:'http://gis.xjtstc.com/iserver/services/3D-local3DCache-wangmu1/rest/realspace/datas/Combine/config'
            },
            {
                code:'wangmu2',
                name:'王母祖庙2',
                modelUrl:'http://gis.xjtstc.com/iserver/services/3D-local3DCache-wangmu2/rest/realspace/datas/Combine/config'
            },
            
        ]
    },
    cls: 'jxwb',//'sh'
    router:{
        login:'/login',
        home:'/index'
    },
    isMock:true, //是否读取模拟数据,
    mockData: '', // 'shihe',// 'babygo'// 'shihe', // 'fusong' // 'beijing'//shihe 
    targetPoi:{
        name:'天山天池',
        coords: [87.9236, 43.5883]
    },
    tiandituKey:"2275c70eb3216152e357bb25b5959695"
   
}

